import axios from 'axios';
import { API_BASE_URL } from '../api';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

export async function createPromotionRequest({ toUserId, promotionType }) {
  const res = await axios.post(
    `${API_BASE_URL}/promotion-requests`,
    { toUserId, promotionType },
    { headers: authHeaders(), timeout: 25000 }
  );
  return res.data;
}

export async function getPendingPromotionRequests() {
  const res = await axios.get(`${API_BASE_URL}/promotion-requests/pending`, {
    headers: authHeaders(),
    timeout: 25000,
  });
  return res.data?.data || { incoming: [], outgoing: [] };
}

export async function getMyPromoters() {
  const res = await axios.get(`${API_BASE_URL}/promotion-requests/my-promoters`, {
    headers: authHeaders(),
    timeout: 25000,
  });
  return res.data?.data?.promoters || [];
}

/** Vendors who accepted the current user's promotion request (for merging their public catalogue into My Fabrics). */
export async function getPromotedVendors() {
  const res = await axios.get(`${API_BASE_URL}/promotion-requests/promoted-vendors`, {
    headers: authHeaders(),
    timeout: 25000,
  });
  return res.data?.data?.vendors || [];
}

export async function getPromotedVendorProducts(vendorId, page = 1, limit = 50, search = '') {
  if (!vendorId) return { products: [], pagination: { hasNextPage: false } };
  const params = { page, limit };
  if (search) params.search = search;
  const res = await axios.get(`${API_BASE_URL}/promotion-requests/vendor/${vendorId}/products`, {
    headers: authHeaders(),
    params,
    timeout: 30000,
  });
  return res.data?.data || { products: [], pagination: { hasNextPage: false } };
}

export async function getPromotedVendorCollections(vendorId, page = 1, limit = 50, search = '') {
  if (!vendorId) return { collections: [], pagination: { hasNextPage: false } };
  const params = { page, limit };
  if (search) params.search = search;
  const res = await axios.get(`${API_BASE_URL}/promotion-requests/vendor/${vendorId}/collections`, {
    headers: authHeaders(),
    params,
    timeout: 30000,
  });
  return res.data?.data || { collections: [], pagination: { hasNextPage: false } };
}

// Public (no-auth): a promoter's public promoted catalogue by phone
export async function getPublicPromoterCollectionsByPhone(phoneNumber, page = 1, limit = 20, search = '') {
  if (!phoneNumber) return { promoter: null, collections: [], pagination: { hasNextPage: false } };
  const normalized = String(phoneNumber).replace(/\D/g, '');
  const params = { page, limit };
  if (search && String(search).trim()) params.search = String(search).trim();
  const res = await axios.get(`${API_BASE_URL}/promotion-requests/public/promoter/${normalized}`, {
    params,
    timeout: 30000,
  });
  return res.data?.data || { promoter: null, collections: [], pagination: { hasNextPage: false } };
}

export async function updatePromotionRequestStatus(id, status) {
  const res = await axios.patch(
    `${API_BASE_URL}/promotion-requests/${id}/status`,
    { status },
    { headers: authHeaders(), timeout: 25000 }
  );
  return res.data;
}

export async function removeApprovedPromoter(requestId) {
  if (!requestId) return;
  const res = await axios.delete(`${API_BASE_URL}/promotion-requests/${requestId}`, {
    headers: authHeaders(),
    timeout: 25000,
  });
  return res.data;
}
